import { useQuery } from '@tanstack/react-query'
import cfClient from '~/modules/core/cfClient'

const getCanfleetNotification = (cfOrgId: string) =>
  cfClient.json.get(`accounts:notification_setting?canfleet-org-id=${cfOrgId}`)

export const useCanfleetNotification = (
  cfOrgId: string,
  enabled: boolean = false,
) =>
  useQuery({
    queryKey: ['canfleetNotification', cfOrgId],
    queryFn: () => getCanfleetNotification(cfOrgId),
    enabled: !!cfOrgId && enabled,
  })
